import * as React from 'react';
import InvoiceFilters from '../InvoiceFilters';
import EnhancedTable from 'src/components/TableInvoices';

import MultipleSelect from '../Filter/AllInvoices';

import settings from '../../../../assets/settings';
import PrintIcon from '../../../../assets/print';
import exportIcon from '../../../../assets/export';
import downarrowIcon from '../../../../assets/downArrow';
import './PaymentMethod.scss';
import PaymentTable from 'src/components/TablesAllInvoices/PaymentTable';
import PaymentHistoryFilters from 'src/components/Invoices/components/PaymentHistoryFilters';
import CustomPaginator from 'src/components/common/CustomPaginator';
// class PaymentMethod extends React.Component<any> {
// public render() {
export default function PaymentMethod(props: any) {
  const [filtervalues, setfiltervalues] = React.useState();
  const [reset, checkReset] = React.useState(false);
  const [cardActive, SetCardActiveStatus] = React.useState(false);

  const getFilterValues = (dates: any) => {
    const filters: any = {
      dateRange: dates,
      status: null,
      orderStatus: null,
      invoiceNumber: null,
      nardaNumber: null,
      orderNumber: null,
      orderReference: null,
      sort: null
    };
  };

  React.useEffect(() => {
    if (reset) {
      getFilterValues({});
      checkReset(false);
    }
  }, [reset]);

  return (
    <div>
      {/* <div className="display">
        <div className="d-flex">
          <div className="Filter-dropdown">
            <MultipleSelect />
          </div>
          <div className="search-clear">
            <InvoiceFilters />
          </div>
        </div>
      </div>
      <div className="paginator-container-display">
        <div className="float-left d-flex icon-rp ">
            <div className="img-border">
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </div>
            <div className="border-bt-tp">
              <img className="image-icon" src={PrintIcon} />
            </div>
            <div className="img-border border-rad">
              <img className="image-icon" src={settings} />
            </div>
          </div>

        <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={1}
              totalPages={20}
              itemsPerPage={5}
              onPageChanged={this.props.handlePagination}
              totalItems={300}
              showPageInfo={true}
              onPageSizeChange={this.props.handlePageSizeChange}
              showPageRangeChange={true}
              currentPageSize={1}
            />
          </div>
      </div> */}
      <div className="d-flex">
        <div className="search-clear">
          <PaymentHistoryFilters
            setfiltervalues={setfiltervalues}
            checkReset={checkReset}
            cardActive={cardActive}
            SetCardActiveStatus={SetCardActiveStatus}
          />
        </div>
      </div>
      <div>
        <PaymentTable filtervalues={filtervalues} />
      </div>
    </div>
  );
  // }
}

// export default PaymentMethod;

// interface IOpenInvoicesProps {
//   t: any;
//   datesFilter: DateRangeModel;
//   statusFilter: statusType;
//   sortFilter: { type: sortType; order: 'asc' | 'desc' };
//   getInvoices(filters: IFiltersInvoice, pagination: IPaginationInvoice): void;
//   clearAlert: () => void;
// }
// interface IOpenInvoicesState {
//   calendarIsOpen: boolean;
// }
